import React from 'react';
import NavigationMenu from './NavigationMenu';
import buildNavItem from '../../../utils/NavItemBuilder';
import {connect} from 'react-redux';
import Loader from '../Loader';

class MeditationsMenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: 0
        };
    }

    buildItems(props) {
        const {categories} = props;
        let items = categories.map( cat => {
            return buildNavItem({
                scrollTo: `category-${cat.id}`,
                text: cat.title,
                // clickHandler: this.toggleExpand.bind(this, cat.id),
                // className: cat.id === this.state.expanded ? "active" : false,
            });
        });

        return items;
    }

    toggleExpand(id) {
        this.setState({
            expanded: (this.state.expanded === id) ? 0 : id
        });
    }

    render() {

        const items = this.buildItems(this.props);
        const {pending} = this.props;
        const className = `${pending ? "loading" : ""} ${this.props.className ? this.props.className : ""}`;
        return <div>
            <Loader show={pending} />
            <NavigationMenu className={className} items={items} />
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        categories: state.category.categories,
        pending: state.category.getCategoriesPending
    }
};

export default connect(mapStateToProps)(MeditationsMenu);


// WEBPACK FOOTER //
// ./src/components/Presentation/Navigation/MeditationsMenu.js